<template>
  <van-popup v-model="localValue" get-container="body" :class="_.dialog">
    <img :src="require('./images/进入中.gif')" :class="_.icon" />
    <div :class="_.message">
      <div v-for="(msg, index) in messages" :key="index">{{ msg }}</div>
    </div>
  </van-popup>
</template>

<script>
  import Messenger from 'vue-messenger'
  import Vue from 'vue'
  import { dcb } from '@dcb/jssdk'

  export default Vue.extend({
    mixins: [Messenger],

    props: {
      value: {
        type: Boolean,
        required: true,
        on: {
          change(visible) {
            if (visible) {
              setTimeout(() => {
                this.localValue = false
                dcb.navigateTo({
                  url: this.url,
                })
              }, 1500)
            }
          },
        },
      },
      message: {
        type: String,
        required: true,
      },
      url: {
        type: String,
        required: true,
      },
    },

    computed: {
      messages() {
        return this.message.split(/\\n|<br\s*\/?>|[\r\n]+/g)
      },
    },
  })
</script>

<style lang="scss" module>
  .dialog {
    width: 299px;
    background: #ffffff;
    border-radius: 13px;
    padding: 36px 60px;
    box-sizing: border-box;
    text-align: center;
    user-select: none;
    overflow: hidden;

    .icon {
      width: 73px;
      height: 73px;
      pointer-events: none;
    }

    .message {
      margin-top: 23px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 25px;
      text-align: center;
    }
  }
</style>
